import type { FC } from "react"

import style from "./style.module.scss"

type Props = {
  text: string
}

const EmptyRow: FC<Props> = ({ text }) => {
  return <div className={style.emptyRow}>{text}</div>
}

export default EmptyRow
